<template>
  <div
    class="segmented-control"
    data-pendo-gc="segmented_control"
  >
    <fieldset
      class="segmented-control__controls"
      :disabled="disabled"
    >
      <SegmentedControlOption
        v-for="control in controls"
        :key="control.value"
        :checked="control.checked"
        :disabled="disabled"
        :icon="control.icon"
        :parent-id="id"
        :text="control.text"
        :value="control.value"
        @update:value="value => $emit('update:value', value)"
      />
    </fieldset>
  </div>
</template>

<script>
  import SegmentedControlOption from './SegmentedControlOption.vue'

  export default {
    name: 'SegmentedControl',
    components: {
      SegmentedControlOption,
    },
    props: {
      controls: {
        type: Array,
        required: true,
        validator: (controls) => controls.every((control) => {
          return 'value' in control && ('text' in control || 'icon' in control)
        }),
      },
      id: { type: String, required: true },
      disabled: { type: Boolean, default: false  },
    },
    emits: ['update:value'],
    data() {
      return {
        hovering: false,
      }
    },
    computed: {
      iconStyle() {
        return this.hovering && !this.disabled ? 'fa-solid' : 'fa-regular'
      },
    },
  }
</script>

<style scoped lang="scss">
.segmented-control {
  display: flex;

  &__controls {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: var(--space-1);
    padding: 2px;
    border: 1px solid #EFF0FA;
    border-radius: 100px;
    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
    text-wrap: nowrap;
  }
}
</style>
